module.exports = __webpack_public_path__ + "static/media/floor-2.0221b70e.png";